<template>
  <v-footer dark padless class="footer-distributed">
    <v-card class="flex white--text text-center" flat tile>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <link
        href="https://fonts.googleapis.com/css?family=Montserrat:100"
        rel="stylesheet"
      />
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="keywords" content="footer, address, phone, icons" />

      <v-card-text>
        <v-row align="center" justify="center" flat tile>
          <div class="footer-far-left">
            <v-col tile cols="auto">
              <div align="center">
              <a :href="Links.DawanHome"  :aria-label="$t('footer.homeDawan')">
                <v-img
                  max-height="110"
                  max-width="110"
                  :src="Links.DawanLogo"
                  alt="Logo Dawan"
                ></v-img
              ></a>
              </div>
              <v-card-text>
                {{ new Date().getFullYear() }} —
                <strong
                  ><a :href="Links.DawanHome" class="footer-link"
                    >Dawan</a
                  ></strong
                >
              </v-card-text>
            </v-col>
          </div>

          <div class="footer-left">
            <v-col tile cols="auto">
              <h2>{{ $t("footer.navigation") }}</h2>
              <div v-for="item in pfooter" :key="item.id">
                <router-link
                  class="footer-link"
                  active-class="active-link"
                  :to="'/' + $i18n.locale + item.link"
                >
                  <span>{{ item.zone }}</span>
                </router-link>
              </div>
            </v-col>
          </div>

          <div class="footer-center">
            <v-col tile cols="auto">
              <h2>{{ $t("footer.navigation") }}</h2>
              <div v-for="item in pfooter2" :key="item.id">
                <router-link
                  class="footer-link"
                  active-class="active-link"
                  :to="'/' + $i18n.locale + item.link"
                >
                  {{ item.zone }}
                </router-link>
              </div>
            </v-col>
          </div>

          <div class="footer-right">
            <v-col tile cols="auto">
              <h2>{{ $t("footer.contactUs") }}</h2>
              <div class="pointer">
                <span
                  class="footer-link"
                  active-class="active-link"
                  @click="decryptEmail('aXRAZGF3YW4uZnI=')"
                  >{{ $t("footer.contactEmail") }}
                </span>
              </div>
            </v-col>
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import router from "@/router/index";
import Links from "@/models/Links"

export default {
  name: "Footer",
  data() {
    return {
      pfooter: [
        { zone: this.$t("nav.calendar"), link: "/calendar" },
        { zone: this.$t("nav.trainings"), link: "/formations" },
        { zone: this.$t("nav.users"), link: "/employes" },
        { zone: "Memento", link: "/memento" },
      ],
      pfooter2: [
        { zone: this.$t("nav.parentEvents"), link: "/eventsparent" },
        { zone: this.$t("nav.locations"), link: "/lieux" },
        { zone: "FAQ", link: "/faq" },
      ],
      Links: Links,
    };
  },
  methods: {
    goTo(route) {
      router.push(route).catch(() => {});
    },
    /**
     * Method to avoid spam from bots with encrypted email address and no "mailto" in the html code.
     * Mailto will be created only after the user click on the link.
     *
     * @param  {String} {encoded} encrypted email
     */
    decryptEmail(encoded) {
      // Get encrypted email address :
      // let buff = new Buffer("test@admin.fr");
      // let base64data = buff.toString('base64');

      // uncrypt email address + open mail
      const code = Buffer.from(encoded, "base64");
      window.location.href = "mailto:" + code;
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

ul {
  list-style-type: none;
  font-size: 15px;
}

h3 {
  font-size: 17px;
  font-family: Montserrat;
  margin: 0 0 10px 0;
}

.icone {
  font-size: 30px;
}

.footer-link {
  color: white !important;
}

.fa {
  padding: 14px;
  font-size: 30px;
  width: 55px;
  text-align: center;
  text-decoration: none;
  border-radius: 75%;
  color: white !important;
}

.fa:hover {
  opacity: 0.7;
}

/* Footer Far Left */

.footer-distributed .footer-far-left {
  width: 20%;
}

/* Footer Left */

.footer-distributed .footer-left {
  width: 20%;
}

/* Footer Center */

.footer-distributed .footer-center {
  width: 30%;
}

/* Footer Right */

.footer-distributed .footer-right {
  width: 20%;
}

.pointer {
  cursor: pointer;
}

/* Here is the code for Responsive Footer */
/* You can remove below code if you don't want Footer to be responsive */

@media (max-width: 880px) {
  .footer-distributed .footer-far-left,
  .footer-distributed .footer-left,
  .footer-distributed .footer-center,
  .footer-distributed .footer-right {
    display: block;
    width: 100%;
    margin-bottom: 40px;
    text-align: center;
    justify-content: center;
    display: flex;
  }
}

/* Set a specific color for each brand */

.fa-facebook {
  background: #3b5998;
}

.fa-twitter {
  background: #55acee;
}

.fa-youtube {
  background: #bb0000;
}
</style>
